import React, { useState } from "react";
import axios from "axios";
import { uploadToCloudinary } from "../../../utils/cloudinary"; 
import { toast } from "react-toastify";
 import Swal from "sweetalert2";

const CareerModal = ({ setShowModal, selectedCareer }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    resume: null,
  });

  const [loading, setLoading] = useState(false);
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.name || !formData.email || !formData.phone || !formData.resume) {
    toast.error("Please fill all fields and upload your resume.");
    return;
  }

  try {
    setLoading(true);
    const resumeUrl = await uploadToCloudinary(formData.resume);
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/career-form/apply`,
      {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        resume: resumeUrl,
      }
    );

    if (response.data.success) {
      Swal.fire({
        title: "Application Submitted!",
        text: "Thank you for applying. We’ll contact you soon.",
        icon: "success",
        confirmButtonColor: "#0bb6d9",
        confirmButtonText: "OK",
      });

      setShowModal(false);
      setFormData({ name: "", email: "", phone: "", resume: null });
    } else {
      toast.error(response.data.message || "Something went wrong.");
    }
  } catch (error) {
    console.error("Application Error:", error);
    Swal.fire({
      title: "Submission Failed",
      text: "There was an error submitting your application. Please try again.",
      icon: "error",
      confirmButtonColor: "#d33",
    });
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="bg-white w-full max-w-md mx-4 rounded-lg shadow-lg p-6 relative">
        <button
          onClick={() => setShowModal(false)}
          className="absolute top-3 right-4 text-gray-600 hover:text-black text-xl"
        >
          ×
        </button>

        <h2 className="text-xl font-semibold mb-4 text-center">
          Apply for {selectedCareer?.position}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Name */}
          <div>
            <label className="block text-sm font-medium mb-1">Full Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#0bb6d9]"
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-sm font-medium mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#0bb6d9]"
            />
          </div>

          {/* Phone */}
          <div>
            <label className="block text-sm font-medium mb-1">Phone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleInputChange}
              required
              className="w-full border rounded-md px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-[#0bb6d9]"
            />
          </div>

          {/* Resume */}
          <div>
            <label className="block text-sm font-medium mb-1">
              Resume (PDF)
            </label>
            <input
              type="file"
              name="resume"
              accept="application/pdf"
              onChange={handleInputChange}
              required
              className="w-full text-sm"
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              onClick={() => setShowModal(false)}
              className="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 text-sm text-white bg-[#0bb6d9] rounded hover:bg-[#179bb6] disabled:opacity-50"
            >
              {loading ? "Submitting..." : "Submit Application"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CareerModal;
